import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useLanguage } from '../../context/LanguageContext';
import { useTranslation } from 'react-i18next';

const Header = () => {
  const navigate = useNavigate();
  const { isAuthenticated, username, logout } = useAuth();
  const [showDropdown, setShowDropdown] = useState(false);
  const { language, setLanguage } = useLanguage();
  const { t, i18n } = useTranslation();

  const location = useLocation();
  const isOnExpertPage = location.pathname.startsWith('/expert');

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const handleLanguageChange = (lang) => {
    localStorage.setItem('selectedLanguage', lang);
    i18n.changeLanguage(lang).then(() => {
      window.location.reload();
    });
  };

  return (
    <header className="w-full border-b border-gray-100">
      <div className="max-w-screen-xl mx-auto px-4 py-2 flex justify-between items-center">
        <Link to="/" className="flex items-center">
          <span className="text-orange-400 font-medium ">Crop</span>
          <span className="text-green-700 font-medium"> Darpan</span>
        </Link>

        <div className="flex items-center space-x-4">
          <div className="relative flex">
            {/* Language selector */}
            <select
              value={localStorage.getItem('selectedLanguage') || 'en_IN'}
              onChange={(e) => handleLanguageChange(e.target.value)}
              className="bg-white-700 text-black border-black rounded text-sm px-3 py-1"
            >
              <option value="en_IN">{t('languages.english')}</option>
              <option value="te_IN">{t('languages.telugu')}</option>
            </select>
              <svg className="w-3 h-3 fill-white" viewBox="0 0 12 12">
                <path d="M6 8L2 4h8L6 8z"/>
              </svg>
          </div>

          {isOnExpertPage && isAuthenticated ? (
            <div className="relative">
              <button
                onClick={() => setShowDropdown(!showDropdown)}
                className="flex items-center text-black hover:text-gray-300 bg-white-700 px-3 py-1 rounded text-sm"
              >
                <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"></path>
                </svg>
                {username || t('expertName')}
              </button>

              {showDropdown && (
                <div className="absolute right-0 mt-2 w-48 bg-white border border-gray-200 rounded shadow-lg z-50">
                  <Link to="/profile/edit" className="block px-4 py-2 hover:bg-gray-100 text-gray-700">{t('expert.login.editProfile')}</Link>
                  <button onClick={handleLogout} className="block w-full text-left px-4 py-2 hover:bg-gray-100 text-gray-700">{t('expert.login.logout')}</button>
                </div>
              )}
            </div>
          ) : (
            <Link to="/expert-home" className="flex items-center text-black hover:text-gray-300 bg-white-700 px-3 py-1 rounded text-sm">
              <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                <path d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"></path>
              </svg>
              {t('expertHomePage')}
            </Link>
          )}
          <Link
            to="/privacy-policy"
            className="text-black hover:text-blue-600 text-sm font-medium"
          >
            {t('privacy.title')}
          </Link>
        </div>          
      </div>
    </header>
  );
};

export default Header;